// src/components/layout/HeaderContainer.js
import React, { useEffect, useState } from 'react';
import { auth, db } from '../../utils/firebase';
import { doc, getDoc } from 'firebase/firestore';
import Header from './Header';

const HeaderContainer = (props) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      // Fetch user doc from Firestore
      getDoc(doc(db, 'users', currentUser.uid))
        .then((snapshot) => {
          if (snapshot.exists()) {
            setUserData(snapshot.data());
          }
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }, []);

  // Construct a user object for <Header />
  // Using the existing user from props if needed
  const userFromAuth = auth.currentUser;
  const user = userFromAuth
    ? {
        // For example, pass email from Firebase Auth
        email: userFromAuth.email,
        // Pass the image from Firestore doc (if available)
        image: userData?.image || null,
      }
    : null;

  return (
    <Header
      user={user}
      {...props}
    />
  );
};

export default HeaderContainer;
